export default __webpack_public_path__ + "static/media/pokemon_black_star_promo.8ff7763f.svg";